var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobility = function SvgMobility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#mobility_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M36.7 29.16s16.535-.062 17.735 0c.052 1.153.07 1.356.07 2.19-.645.012-14.846.125-17.49.142a21 21 0 0 1-.316-2.332"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M26 19.75h8.89l2.28 14.433M39.278 55.75c5.2 0 9.414-4.828 9.414-10.783 0-5.956-4.215-10.784-9.414-10.784s-9.413 4.828-9.413 10.784c0 5.955 4.215 10.783 9.413 10.783"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.279 51.741c3.102 0 5.616-2.88 5.616-6.434 0-3.553-2.514-6.434-5.616-6.434s-5.617 2.88-5.617 6.434 2.515 6.434 5.617 6.434"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.28 47.31c1.129 0 2.045-1.05 2.045-2.343 0-1.295-.916-2.344-2.046-2.344s-2.046 1.05-2.046 2.344.916 2.343 2.046 2.343M54.82 55.75c1.76 0 3.187-1.634 3.187-3.65s-1.427-3.65-3.186-3.65c-1.76 0-3.186 1.634-3.186 3.65s1.426 3.65 3.186 3.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M54.826 53.31c.603 0 1.092-.561 1.092-1.253 0-.69-.489-1.251-1.092-1.251s-1.093.56-1.093 1.252c0 .69.49 1.251 1.093 1.251"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m35.278 40.793 2.455 2.642M42.944 40.793l-2.12 2.642M40.58 46.775l2.707 3.036M37.733 46.775l-2.461 3.036M40.456 34.267l14-.084 1.451 10.784h-7.215s-.572-9.59-8.236-10.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M58.602 46.434h2.803c.329 0 .595.311.595.694v.364c0 .383-.266.694-.595.694h-2.803c-.329 0-.595-.311-.595-.694v-.364c0-.383.266-.694.595-.694"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mobility_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2710_35548"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2710_35548",
    result: "shape"
  })))));
};
export default SvgMobility;